import React from 'react';
import { Icon } from './Icon.js';
export const IconTextFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6,11.5c-.414,0-.75-.336-.75-.75V1.25c0-.414.336-.75.75-.75s.75.336.75.75v9.5c0,.414-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("path", { d: "m10,2H2c-.414,0-.75-.336-.75-.75s.336-.75.75-.75h8c.414,0,.75.336.75.75s-.336.75-.75.75Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconTextFill12.js.map